var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAsterisk = function SvgIconAsterisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.75a1 1 0 0 1 1 1v6.518l5.644-3.259a1 1 0 0 1 1 1.732L14 12l5.644 3.259a1 1 0 0 1-1 1.732L13 13.732v6.518a1 1 0 0 1-2 0v-6.518l-5.643 3.259a1 1 0 0 1-1-1.732L10 12 4.357 8.741a1 1 0 0 1 1-1.732L11 10.268V3.75a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconAsterisk;